// @flow

import Vue from 'vue'
import Vuex from 'vuex'

import { actions } from './actions'
import { mutations } from './mutations'
import { getters } from './getters'
import { createState } from './state'

Vue.use(Vuex)

export function createStore (customerId: string, subscriberId: string, parentUrl: string, integrationId: string): any {
  return new Vuex.Store({
    state: createState(customerId, subscriberId, parentUrl, integrationId),
    mutations,
    actions,
    getters
  })
}
